(() => {
  'use strict';
  if (customElements.get('kalk-pack-combination')) return;
  class KalkPackCombination extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('[data-pack-submit]');
      this.label = this.querySelector('[data-pack-label]');
      this.total = this.querySelector('[data-pack-total]');
      this.status = this.querySelector('[data-pack-status]');
      this.options = Array.from(this.querySelectorAll('input[type="checkbox"], input[type="radio"]'));
      this.fixedAvailable = this.dataset.fixedAvailable === 'true';
      this.submitting = false;
      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'EUR'});
      this.addEventListener('change', (event) => { if (this.options.includes(event.target) && !this.submitting) this.updateSelection(); });
      this.button.addEventListener('click', () => this.addCombination());
      this.updateSelection();
    }
    selectedOptions() { return this.options.filter((option) => option.checked && !option.disabled); }
    combinationItems(selected) {
      const ids = [this.dataset.fixedVariantId, ...selected.map((option) => option.value)].map(Number);
      if (ids.some((id) => !Number.isSafeInteger(id) || id <= 0) || new Set(ids).size !== ids.length) return null;
      return ids.map((id) => ({id, quantity:1}));
    }
    updateSelection() {
      const selected = this.selectedOptions();
      this.button.disabled = this.submitting || !this.fixedAvailable || !selected.length;
      this.total.hidden = !selected.length;
      if (this.fixedAvailable) this.setStatus('');
      if (!selected.length) {
        this.label.textContent = this.fixedAvailable ? this.dataset.selectLabel : this.dataset.unavailableLabel;
        this.total.textContent = '';
        return;
      }
      this.label.textContent = this.dataset.addLabel.replace(/__SCARF__|__BEANIE__/g, (token) => token==='__SCARF__' ? this.dataset.fixedName : selected.map((option) => option.dataset.name).join(', '));
      const amount = selected.reduce((sum, option) => sum + Number(option.dataset.price), Number(this.dataset.fixedPrice));
      this.total.textContent = `· ${this.formatter.format(amount / 100)}`;
    }
    setStatus(message, isError=false, showCartLink=false) {
      this.status.textContent = message;
      this.status.dataset.error = String(isError);
      if (showCartLink) {
        const link = document.createElement('a');
        link.href = this.cartUrl();
        link.textContent = this.dataset.viewCartLabel;
        link.className = 'kalk-pack-combination__cart-link';
        this.status.append(' ',link);
      }
    }
    setSubmitting(submitting) {
      this.submitting = submitting;
      this.button.disabled = submitting || !this.fixedAvailable || !this.selectedOptions().length;
      this.button.setAttribute('aria-busy',String(submitting));
      this.options.forEach((option) => {
        if (submitting) {
          option.dataset.previouslyDisabled = String(option.disabled);
          option.disabled = true;
        } else {
          option.disabled = option.dataset.previouslyDisabled === 'true';
          delete option.dataset.previouslyDisabled;
        }
      });
      if (submitting) this.label.textContent=this.dataset.addingLabel;
      else this.updateSelection();
    }
    async addCombination() {
      if (this.submitting || !this.fixedAvailable) return;
      const selected = this.selectedOptions();
      if (!selected.length) return;
      const items = this.combinationItems(selected);
      if (!items) {
        this.setStatus(this.dataset.invalidMessage,true);
        return;
      }
      this.setStatus('');
      this.setSubmitting(true);
      let errorMessage='';
      let succeeded=false;
      let showCartLink=false;
      try {
        const theme=this.getTheme();
        const sections=[];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
        const response=await fetch(theme?.routes?.cart_add_url || `${this.rootUrl()}cart/add.js`,{
          ...(theme?.utils?.fetchConfig?.() || {}),
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items,sections,sections_url:window.location.pathname})
        });
        const result=await response.json();
        if (!response.ok || result.status) {
          errorMessage=typeof result.description==='string' ? result.description : this.dataset.addErrorMessage;
          showCartLink=true;
          this.refreshCartOnError();
          return;
        }
        succeeded=true;
        await this.updateCart(result);
      } catch(error) {
        errorMessage=succeeded ? this.dataset.addedOpenCartMessage : this.dataset.unconfirmedMessage;
        showCartLink=true;
        this.refreshCartOnError();
      } finally {
        this.setSubmitting(false);
        if (errorMessage) this.setStatus(errorMessage,!succeeded,showCartLink);
        else if(succeeded) this.setStatus(this.dataset.addedMessage);
      }
    }
    async updateCart(result) {
      const theme=this.getTheme();
      const drawer=document.querySelector('cart-drawer');
      if(theme?.settings?.cartType==='page' || !drawer || typeof drawer.show!=='function') {
        window.location.assign(this.cartUrl());
        return;
      }
      const response=await fetch(`${this.rootUrl()}cart.js`,{...(theme?.utils?.fetchConfig?.() || {}),method:'GET',credentials:'same-origin',headers:{Accept:'application/json'}});
      if(!response.ok) throw new Error('Unable to refresh cart');
      const cart=await response.json();
      cart.sections=result.sections;
      if(theme?.pubsub?.publish && theme.pubsub.PUB_SUB_EVENTS?.cartUpdate) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart});
      else document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
      document.dispatchEvent(new CustomEvent('product-ajax:added',{detail:{product:result}}));
      drawer.show(this.button);
    }
    getTheme() { return typeof FoxTheme!=='undefined' ? FoxTheme : window.FoxTheme; }
    rootUrl() { return window.Shopify?.routes?.root || this.getTheme()?.routes?.root_url || '/'; }
    cartUrl() { return `${this.rootUrl()}cart`; }
    refreshCartOnError() {
      if(document.querySelector('cart-drawer')) document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
    }
  }
  customElements.define('kalk-pack-combination',KalkPackCombination);
})();
